module.exports = __webpack_public_path__ + "static/media/en.c4cd6642.svg";